import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {    
    code: null, //string, optional // Mã của cấu hình
    roles: [], //array of string, optional // Danh sách quyền được phép lấy về thông tin cấu hình
    value: null //string, optional // Giá trị cấu hình
};

// validation form
model.validForm = {   
    code: [ValidService.required], //string, optional // Mã của cấu hình
    roles: [], //array of string, optional // Danh sách quyền được phép lấy về thông tin cấu hình
    value: [] //string, optional // Giá trị cấu hình
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["code", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            code: "",
            value: "",
            roles: []
        },
        valid: {
            code: [],
            value: [],
            roles: [],
        },
        operator: {
            code: ":regex_i:", //:regex:, $vn_text=Viêt nam
            value: ":regex_i:"
        }
    }
};

export default model;